import {createStrokeSVG} from './TEMPLATE'

// tabler: source-code
export const CodeLines_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M14.5 4h2.5a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-5',
    'M6 5l-2 2l2 2',
    'M10 9l2 -2l-2 -2',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
